__turbopack_context__.v({
  "chevron": "_3quInG_chevron",
  "row": "_3quInG_row",
  "rowDelete": "_3quInG_rowDelete",
  "subtitle": "_3quInG_subtitle",
  "textWrap": "_3quInG_textWrap",
  "title": "_3quInG_title",
});
